import { Pipe, PipeTransform } from '@angular/core';
import Autolinker from 'autolinker';

@Pipe({ name: 'linkify' })
export class LinkifyPipe implements PipeTransform {
  transform(text: string) {
    // https://github.com/gregjacobs/Autolinker.js
    const options = { newWindow: true };
    return Autolinker.link(text, options);
  }
}
